import { t } from '../i18n/lingua'

/**
 * Come si prepara un FortiGate per CENSO: il profilo in sola lettura, il REST
 * API Admin legato all'IP della sonda, i log che servono al traffico e alle
 * minacce, e la sonda con la capability «Firewall». Accanto al modulo della
 * credenziale «Fortinet FortiGate», chiusa di default. Il testo completo è in
 * docs/operations/fortinet-firewall.md.
 */
export function GuidaFortinet() {
  return (
    <details className="guida-chiave">
      <summary>{t('Come preparo il FortiGate per CENSO (utente API e log)?')}</summary>
      <div className="guida-chiave__corpo">
        <p>
          {t(
            'CENSO interroga il FortiGate in tempo reale con la REST API di FortiOS, attraverso una sonda che raggiunge la sua interfaccia di gestione. Serve un amministratore «REST API Admin» in sola lettura: CENSO non cambia nulla sul firewall.',
          )}
        </p>
        <h4>{t('A) Il profilo in sola lettura')}</h4>
        <ol>
          <li>
            {t(
              'System → Admin Profiles → Create New: un nome (per esempio «censo-readonly») e «Read» su tutte le voci; in particolare «Log & Report» (per traffico, minacce e web filter), «System» (stato, sessioni, amministratori), «Network» (rotte) e «VPN».',
            )}
          </li>
          <li>{t('Nessuna voce in «Read/Write»: a CENSO basta leggere.')}</li>
        </ol>
        <h4>{t('B) L’utente API e la chiave')}</h4>
        <ol>
          <li>
            {t(
              'System → Administrators → Create New → REST API Admin: un nome (per esempio «censoapi»), il profilo del passo A e, con più VDOM, il VDOM da leggere.',
            )}
          </li>
          <li>
            {t(
              'In «Trusted Hosts» metti l’IP della sonda che interroga il firewall (o la sua rete, per esempio 10.0.12.5/32): la chiave vale solo da lì.',
            )}
          </li>
          <li>
            {t(
              'Disattiva «PKI Group» e, se non serve, «CORS». Conferma: FortiOS mostra la chiave una volta sola. Copiala qui, nel campo «Chiave API».',
            )}
          </li>
          <li>
            {t(
              'Dalla riga di comando è lo stesso: «config system api-user», poi «edit censoapi», «set accprofile censo-readonly», «config trusthost» con l’IP della sonda, e infine «execute api-user generate-key censoapi».',
            )}
          </li>
        </ol>
        <h4>{t('C) I log che CENSO legge')}</h4>
        <ol>
          <li>
            {t(
              'Nelle policy di cui vuoi vedere il traffico imposta «Log Allowed Traffic» su «All Sessions» (oppure «Security Events» per i soli eventi UTM). Il traffico negato si registra con «Log Violation Traffic», attivo di default sulla policy implicita.',
            )}
          </li>
          <li>
            {t(
              'Per minacce e web filter servono i profili di sicurezza (IPS, antivirus, web filter, application control) applicati alle policy: senza, quelle viste restano vuote.',
            )}
          </li>
          <li>
            {t(
              'Log & Report → Log Settings: dove tieni i log (memoria, disco, FortiAnalyzer o FortiCloud). CENSO lo ricava da solo; se vuoi forzarlo, compila «Dove sono i log». In memoria i log sono pochi e si perdono al riavvio: per una storia utile usa disco o FortiAnalyzer.',
            )}
          </li>
        </ol>
        <h4>{t('D) La sonda')}</h4>
        <ol>
          <li>
            {t(
              'Sulla scheda della sonda che raggiunge la gestione del firewall abilita la capability «Firewall» e scegli quella sonda qui sotto: le richieste escono solo da lì.',
            )}
          </li>
          <li>
            {t(
              'Il certificato della console di solito è autofirmato: incolla la CA o l’impronta SHA-256 nei campi TLS, invece di disattivare la verifica.',
            )}
          </li>
        </ol>
      </div>
    </details>
  )
}
